<template>
  <div class="d-flex flex-column">
    <file-form-field
      ref="uploader"
      class="mb-0"
      :label="label"
      multiple
      @input="add(...$event)">
    </file-form-field>
    <slot name="advice"></slot>
    <data-table
      condensed
      ref="dt"
      :stacked="isSmDown"
      v-if="value && value.length"
      class="flex-grow-1"
      :columns="columns"
      :value="value"
    />
    <div class="text-right" v-if="value.length">
      <b-button
        variant="danger"
        @click.prevent="clear()">
        <i class="fa fa-fw fa-times"></i>
        {{ $t('fileTable.removeAll') }}
      </b-button>
      <b-button
        variant="success"
        @click.prevent="upload()">
        <i class="fa fa-fw fa-upload"></i>
        {{ $t('fileTable.uploadAll') }}
      </b-button>
    </div>
  </div>
</template>
<script>
import { renameFile } from 'core/utils';

export default {
  props: {
    restrict: {
      type: String,
      default: undefined
    },

    label: {
      type: String,
      default: undefined
    },

    value: {
      type: Array,
      default: () => []
    },

    customColumns: {
      type: Array,
      default: () => []
    },

    customActions: {
      type: Function,
      default: () => []
    },

    /**
     * Returns error string
     */
    validateFile: {
      type: Function,
      default: (/*file*/) => undefined
    }
  },

  data() {
    return {
      progress: {}
    };
  },

  created() {
    this.columns = [
      {
        label: () => this.$t('fileTable.name'),
        styleClass: ({ row }) => 'col-12 font-weight-bold' + (!row || this.isValid(row) ? '' : ' bg-danger text-white'),
        value: ({ row }) => row.name
      },
      {
        label: () => this.$t('fileTable.size'),
        styleClass: ({ row }) => 'col-2' + (!row || this.isValid(row) ? '' : ' bg-danger text-white'),
        value: ({ row }) => this.$number2fileSize(row.size)
      },
      {
        label: () => this.$t('fileTable.progress'),
        type: 'progress',
        styleClass: ({ row }) => 'col-4 mb-0' + (!row || this.isValid(row) ? '' : ' bg-danger text-white'),
        value: ({ row }) => this.getProgress(row),
      },
      {
        //label: 'Azioni',
        styleClass: ({ row }) => 'col-6 text-right' + (!row || this.isValid(row) ? '' : ' bg-danger text-white'),
        type: 'actions',
        actions: [
          {
            icon: 'trash',
            variant: 'danger',
            label: () => this.$t('common.remove'),
            action: ({ r }) => this.remove(r)
          },
          {
            icon: 'pen',
            variant: 'warning',
            label: () => this.$t('common.rename'),
            action: ({ r }) => this.rename(r)
          },
          //...this.customActions(row, r),
          {
            icon: 'upload',
            variant: 'success',
            label: () => this.$t('common.upload'),
            action: ({ r }) => this.upload(r),
            disabled: ({ row }) => !!this.validateFile(row)
          },
        ]
      },
      {
        label: () => this.$t('fileTable.error'),
        value: ({ row }) => this.getError(row) || this.validateFile(row),
        styleClass: ({ row }) => 'col-12' + (!row || this.isValid(row) ? '' : ' bg-danger text-white'),
      },
    ];
  },

  methods: {
    isValid(file) {
      return !(this.getError(file) || this.validateFile(file));
    },

    getProgress(file) {
      if (!this.progress || !this.progress[file.id]) {
        return 0;
      }
      return this.progress[file.id].percentage || 0;
    },

    getError(file) {
      if (!this.progress || !this.progress[file.id]) {
        return undefined;
      }
      const error = this.progress[file.id].error;
      return error && error.message;
    },

    setProgress(file, loaded, total) {
      const percentage = loaded * 100 / total;
      const progress = { ...this.progress };
      progress[file.id] = { loaded, total, percentage };
      this.progress = progress;
    },

    setError(file, error) {
      const progress = { ...this.progress };
      progress[file.id] = { error };
      this.progress = progress;
    },

    accept(file) {
      if (this.restrict) {
        const extensions = this.restrict.split(',')
            .map(x => {
              let ret = x.trim().toLowerCase();
              if (ret.startsWith('*.')) {
                ret = ret.substring(2);
              }
              return ret;
            });
        for (let e of extensions) {
          if (file.name.toLowerCase().endsWith(e)) {
            return true;
          }
        }
        return false;
      }
      return true;
    },

    reset() {
      this.$refs.uploader.reset();
    },

    add(...files) {
      //console.log('Adding files', ...files);
      if (!files || files.length < 1) {
        //this.$emit('input', this.value);
        //this.reset();
        return;
      }
      const newFiles = [ ...this.value ];
      for (let file of files) {
        if (this.accept(file) && !newFiles.find(f => this.$isSameFile(file, f))) {
          file.id = this.$uuid();
          newFiles.push(file);
        }
      }
      this.reset();
      this.$emit('input', newFiles);
    },

    clear() {
      this.$emit('input', []);
    },

    remove(index) {
      const value = [ ...this.value ];
      value.splice(index, 1);
      this.$emit('input', value);
    },

    rename(index) {
      const oldName = this.value[index].name;
      let newName = prompt(this.$t('common.rename'), oldName);
      if (newName) {
        newName = newName.trim();
        if (newName) {
          const value = [ ...this.value ];
          const properties = { ...value[index] };
          value[index] = renameFile(value[index], newName);
          for (let k in properties) {
            value[index][k] = properties[k];
          }
          this.$emit('input', value);
        }
      }
    },

    upload(index) {
      if (index === undefined) {
        this.$emit('upload', this.value);
      } else {
        this.$emit('upload', [ this.value[index] ]);
      }
    }
  }
};
</script>
